import { render } from "./FlexibleTabs.vue?vue&type=template&id=6a51b7ca"
import script from "./FlexibleTabs.vue?vue&type=script&lang=js"
export * from "./FlexibleTabs.vue?vue&type=script&lang=js"

import "./FlexibleTabs.vue?vue&type=style&index=0&id=6a51b7ca&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__